import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Apis from "../../../Apis";
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from "../../../../services/firebase.js";
import { showAlert } from '../../../ui/dialog';
import { FaGoogle } from 'react-icons/fa';

const Spinner = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" style={{ animation: 'ge-spin 0.8s linear infinite' }}>
    <circle cx="9" cy="9" r="7" fill="none" stroke="#9ca3af" strokeWidth="2" strokeDasharray="22 22" strokeLinecap="round" />
    <style>{`@keyframes ge-spin{to{transform:rotate(360deg);}}`}</style>
  </svg>
);

const DARK = '#1e3a4c';
const DARK_HOVER = '#162e3c';

const inputBase = {
  width: '100%', height: 42, padding: '0 12px',
  border: '1px solid #d1d5db', borderRadius: 4,
  fontSize: 14, fontFamily: 'inherit', color: '#111827',
  background: '#fff', outline: 'none', boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};

const steps = ['Empresa', 'Segurança'];

const EyeOpen = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const EyeOff = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

function Field({ label, type = 'text', value, onChange, placeholder, showToggle, show, onToggle }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>{label}</label>
      <div style={{ position: 'relative' }}>
        <input
          type={showToggle ? (show ? 'text' : 'password') : type}
          value={value} onChange={onChange} placeholder={placeholder}
          style={{ ...inputBase, paddingRight: showToggle ? 40 : 12 }}
          onFocus={e => e.target.style.borderColor = DARK}
          onBlur={e => e.target.style.borderColor = '#d1d5db'}
        />
        {showToggle && (
          <button type="button" onClick={onToggle} style={{
            position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: 4, display: 'flex',
          }}>
            {show ? <EyeOff /> : <EyeOpen />}
          </button>
        )}
      </div>
    </div>
  );
}

export default function CadastrarEmpresa() {
  const navigate = useNavigate();
  const [step, setStep]                     = useState(0);
  const [nome, setNome]                     = useState('');
  const [cnpj, setCnpj]                     = useState('');
  const [email, setEmail]                   = useState('');
  const [imagemLogin, setImagemLogin]       = useState('');
  const [senha, setSenha]                   = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [showPwd, setShowPwd]               = useState(false);
  const [showPwd2, setShowPwd2]             = useState(false);
  const [loading, setLoading]               = useState(false);
  const [photoURL, setPhotoURL]             = useState('');

  const alertErr = (msg) => showAlert({ title: 'Atenção', text: msg, icon: 'error', dangerMode: true });

  const handleGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then(result => {
        setEmail(result.user.email);
        setNome(result.user.displayName);
        setImagemLogin(result.user.photoURL);
        setPhotoURL(result.user.photoURL);
      })
      .catch(err => console.log(err));
  };

  const handleNext = () => {
    if (!nome || !email) { alertErr('Preencha nome e e-mail da empresa'); return; }
    setStep(1);
  };

  const handleSubmit = () => {
    if (!senha || !confirmarSenha) { alertErr('Preencha a senha'); return; }
    if (senha !== confirmarSenha) { alertErr('As senhas não coincidem'); return; }
    setLoading(true);
    fetch(Apis.urlCadastrarEmpresas, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, nome, cnpj, senha, imagem_login: imagemLogin }),
    })
      .then(r => r.json())
      .then(res => {
        if (res.retorno.sucesso) {
          navigate(`/alerta-suces//${res.retorno.mensagem}&login`);
        } else {
          alertErr(res.retorno.mensagem);
        }
      })
      .catch(() => alertErr('Erro ao conectar. Tente novamente.'))
      .finally(() => setLoading(false));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', maxWidth: 1920, margin: '0 auto' }}>

      {/* ── Left panel ── */}
      <div style={{
        flex: 1, background: DARK,
        flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        padding: '48px 56px', position: 'relative', overflow: 'hidden',
        display: window.innerWidth < 900 ? 'none' : 'flex',
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.04,
          backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)',
          backgroundSize: '40px 40px',
        }} />

        <div style={{ position: 'relative', textAlign: 'center' }}>
          <h2 style={{ color: '#fff', fontSize: 32, fontWeight: 700, lineHeight: 1.25, margin: '0 0 16px', letterSpacing: '-0.5px' }}>
            Comece agora<br />
            <span style={{ color: '#94b8cc' }}>gratuitamente.</span>
          </h2>
          <p style={{ color: '#6b8fa3', fontSize: 14, lineHeight: 1.75, margin: '0 0 40px' }}>
            Configure sua empresa em menos de 2 minutos.
          </p>

          {['Cadastro rápido e simples', 'Sem cartão de crédito', 'Acesso imediato', 'Suporte incluído'].map(f => (
            <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 14 }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#3d6a85', flexShrink: 0 }} />
              <span style={{ color: '#8ab0c4', fontSize: 13.5 }}>{f}</span>
            </div>
          ))}
        </div>

        <p style={{ position: 'absolute', bottom: 32, color: '#3d6a85', fontSize: 12, margin: 0 }}>
          © {new Date().getFullYear()} GE Sistemas
        </p>
      </div>

      {/* ── Right form ── */}
      <div style={{
        flex: 1, background: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '48px 40px', boxSizing: 'border-box',
        borderLeft: '1px solid #e5e7eb',
      }}>
        <div style={{ width: '100%', maxWidth: 400 }}>

          <div style={{ marginBottom: 32 }}>
            <h1 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 700, color: '#111827', letterSpacing: '-0.3px' }}>
              Criar conta
            </h1>
            <p style={{ margin: 0, fontSize: 13.5, color: '#6b7280' }}>
              {step === 0 ? 'Dados da sua empresa' : 'Defina uma senha de acesso'}
            </p>
          </div>

          {/* Step indicator */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 28 }}>
            {steps.map((s, i) => (
              <React.Fragment key={i}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <div style={{
                    width: 22, height: 22, borderRadius: '50%',
                    background: i <= step ? DARK : '#f3f4f6',
                    color: i <= step ? '#fff' : '#9ca3af',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11, fontWeight: 700, flexShrink: 0,
                  }}>
                    {i < step ? '✓' : i + 1}
                  </div>
                  <span style={{ fontSize: 12, color: i === step ? DARK : '#9ca3af', fontWeight: i === step ? 600 : 400 }}>
                    {s}
                  </span>
                </div>
                {i < steps.length - 1 && (
                  <div style={{ flex: 1, height: 1, background: i < step ? DARK : '#e5e7eb' }} />
                )}
              </React.Fragment>
            ))}
          </div>

          {step === 0 && (
            <>
              {photoURL && (
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  <img src={photoURL} alt="" style={{ width: 56, height: 56, borderRadius: '50%', objectFit: 'cover', border: '2px solid #e5e7eb' }} />
                </div>
              )}
              <Field label="Nome da empresa *" value={nome} onChange={e => setNome(e.target.value)} placeholder="Nome da empresa" />
              <Field label="CNPJ" value={cnpj} onChange={e => setCnpj(e.target.value)} placeholder="CNPJ (opcional)" />
              <Field label="E-mail *" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-mail de acesso" />

              <button type="button" onClick={handleGoogle} style={{
                width: '100%', height: 40, borderRadius: 4, marginBottom: 20,
                border: '1px solid #e5e7eb', background: '#fff', color: '#374151',
                fontSize: 13, fontWeight: 500, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                fontFamily: 'inherit', transition: 'background 0.15s',
              }}
                onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                onMouseLeave={e => e.currentTarget.style.background = '#fff'}
              >
                <FaGoogle size={14} color="#ea4335" /> Preencher com Google
              </button>

              <button onClick={handleNext} style={{
                width: '100%', height: 42, borderRadius: 4, border: 'none',
                background: DARK, color: '#fff', fontSize: 14, fontWeight: 600,
                cursor: 'pointer', fontFamily: 'inherit', transition: 'background 0.15s',
              }}
                onMouseEnter={e => e.currentTarget.style.background = DARK_HOVER}
                onMouseLeave={e => e.currentTarget.style.background = DARK}
              >
                Próximo
              </button>
            </>
          )}

          {step === 1 && (
            <>
              <Field label="Senha *" value={senha} onChange={e => setSenha(e.target.value)} placeholder="Crie uma senha"
                showToggle show={showPwd} onToggle={() => setShowPwd(p => !p)} />
              <Field label="Confirmar senha *" value={confirmarSenha} onChange={e => setConfirmarSenha(e.target.value)} placeholder="Repita a senha"
                showToggle show={showPwd2} onToggle={() => setShowPwd2(p => !p)} />

              <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
                <button onClick={() => setStep(0)} style={{
                  flex: 1, height: 42, borderRadius: 4,
                  border: '1px solid #d1d5db', background: '#fff', color: '#374151',
                  fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', transition: 'background 0.15s',
                }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                  onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                >
                  Voltar
                </button>
                <button onClick={handleSubmit} disabled={loading} style={{
                  flex: 2, height: 42, borderRadius: 4, border: 'none',
                  background: loading ? '#e5e7eb' : DARK,
                  color: loading ? '#9ca3af' : '#fff',
                  fontSize: 14, fontWeight: 600, cursor: loading ? 'default' : 'pointer',
                  fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'background 0.15s',
                }}
                  onMouseEnter={e => { if (!loading) e.currentTarget.style.background = DARK_HOVER; }}
                  onMouseLeave={e => { if (!loading) e.currentTarget.style.background = DARK; }}
                >
                  {loading ? <Spinner /> : 'Criar conta'}
                </button>
              </div>
            </>
          )}

          <div style={{ marginTop: 24 }}>
            <span style={{ fontSize: 13, color: '#9ca3af' }}>Já tem uma conta? </span>
            <button onClick={() => navigate('/login')} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: DARK, fontSize: 13, fontWeight: 500, fontFamily: 'inherit',
              textDecoration: 'underline', textUnderlineOffset: 3,
            }}>
              Entrar
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
